
import {Component, Vue, Watch} from "vue-property-decorator";
import {safetyModule, studyModule} from "@/store";
import {formatDate, formatDateTime} from "@/auxillary/date-format";
import {translate} from "@/auxillary/translation";
import {MdbsCore} from "@/api/tsclient";
import ISafetyReportEntry = MdbsCore.ISafetyReportEntry;

@Component({
  components: {},
  filters: {
    formatDate,
    formatDateTime,
    translate
  }
})
export default class SafetyFreeTextReport extends Vue {

  headers: any = [
    {text: 'Patient', value: 'patientName'},
    {text: 'Visite', value: 'visitIdentifier'},
    {text: 'Instrument', value: 'instrumentIdentifier'},
    {text: 'Feld', value: 'fieldName'},
    {text: 'Wert', value: 'fieldValue', width: 300},
    {text: 'Datum', value: 'fieldChangedDate'},
  ];
  options: any = {
    sortBy: ['fieldChangedDate'],
    sortDesc: [true]
  };
  footerOptions: any = {
    'items-per-page-options': [50, 250, 1000, -1]
  };

  fromDate: string = this.createDateString(-7);
  datePickerOpen: boolean = false;

  get safetyReportEntries() {
    return safetyModule.SafetyFreeTextReport.entries;
  }

  get loading() {
    return safetyModule.isLoading;
  }

  get today() {
    return this.createDateString();
  }

  get studyName() {
    return studyModule.study.displayName;
  }

  async mounted() {
  }

  private createDateString(dayOffset: number = 0): string {
    const now = new Date();
    return new Date(now.setDate(now.getDate() + dayOffset)).toISOString().substr(0, 10);
  }

  @Watch("fromDate", {immediate: true})
  async onFromDateChanged() {
    await this.loadSafetyReport();
  }

  private async loadSafetyReport() {
    await safetyModule.loadSafetyFreeTextReport({fromDate: new Date(this.fromDate)});
  }

  private resolveInstrumentRoute(item: ISafetyReportEntry): void {
    const route: any = item.visitId
        ? {
          name: 'visitinstrumentedit',
          params: {
            patientId: item.patientId!,
            visitId: item.visitId!,
            instrumentId: item.instrumentId!
          }
        }
        : {
          name: 'standaloneinstrumentedit',
          params: {
            patientId: item.patientId!,
            instrumentId: item.instrumentId!
          }
        };

    this.$router.push(route);
  }

  private resolveVisitRoute(item: ISafetyReportEntry): void {
    const route: any =  {
      name: 'visitedit',
      params: {
        patientId: item.patientId!,
        visitId: item.visitId!,
      }
    };

    this.$router.push(route);
  }

  private resolvePatientRoute(item: ISafetyReportEntry): void {
    const route: any =  {
      name: 'patientedit',
      params: {
        patientId: item.patientId!
      }
    };

    this.$router.push(route);
  }

}
